import {useEffect, useState} from "react";
import axios from "axios";
import {API_URL} from "../../../../config";

// The one RSO on/off switch. ON = Sales see the RSO tile and can send; OFF = the tile is hidden
// and NANCY refuses every Sales RSO request. Admin and President flip it on the Admin page.
//   GET  Dashboard/api/RsoSwitch            (anyone signed in) -> {enabled, canManage, lastChange}
//   POST Dashboard/api/RsoSwitch {enabled}  (manage-rso-input-window) -> the same
export const RSO_SWITCH_ENDPOINT = `${API_URL}/Dashboard/api/RsoSwitch`;

const isRecord = (value) => value !== null && typeof value === "object" && !Array.isArray(value);
// Only a clear yes/no counts; anything else is "unknown" and the tile stays as it is.
export const normalizeSwitch = (data) => {
  if (!isRecord(data) || typeof data.enabled !== "boolean") return null;
  const change = isRecord(data.lastChange) ? data.lastChange : null;
  return {enabled: data.enabled, canManage: data.canManage === true,
    lastChange: change && typeof change.changedOnUtc === "string" && !Number.isNaN(Date.parse(change.changedOnUtc))
      ? {enabled: change.enabled === true, changedByName: typeof change.changedByName === "string" ? change.changedByName.trim() : "", changedOnUtc: change.changedOnUtc}
      : null};
};

const headers = (token) => ({Authorization: `Bearer ${token}`});
const checked = (response) => {
  const value = normalizeSwitch(response?.data);
  if (!value) throw new Error("Invalid RSO switch");
  return value;
};
export const readRsoSwitch = async (token) => checked(await axios.get(RSO_SWITCH_ENDPOINT, {headers: headers(token), timeout: 30000}));
export const setRsoSwitch = async (token, enabled) => checked(await axios.post(RSO_SWITCH_ENDPOINT, {enabled: !!enabled},
  {headers: headers(token), timeout: 30000}));

// Read-only hook: {loading, value}. loading is true until NANCY answers; value is null when it
// could not answer (the caller then treats RSO as on: NANCY refuses sends itself while it is off).
export default function useRsoSwitch({token, enabled = true}) {
  const active = enabled && !!token;
  const [state, setState] = useState({token: null, value: null});
  useEffect(() => {
    if (!active) return undefined;
    let current = true;
    readRsoSwitch(token).then((value) => {if (current) setState({token, value});})
      .catch(() => {if (current) setState({token, value: null});});
    return () => {current = false;};
  }, [active, token]);
  const answered = !active || state.token === token;
  return {loading: !answered, value: answered && active ? state.value : null};
}
